/**
 * Global JavaScript utilities
 */

// Smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// Cart refresh event
document.documentElement.addEventListener('cart:refresh', async () => {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  
  // Update cart count
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = cart.item_count;
  });
});

// Add to cart notifications
window.addEventListener('cart:added', (e) => {
  console.log('Product added to cart', e.detail);
});

